// extracted by mini-css-extract-plugin
export default {"contentModal":"AdminDialog_contentModal__SJKSP","contentModalBtn":"AdminDialog_contentModalBtn__BwoHG","list":"AdminDialog_list__MJsF4"};